<template>
  <v-card>
    <v-card-title class="title">Usuarios</v-card-title>
    <v-card-text>
      <v-row>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            autocomplete="off"
            class="pl-2"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col md="2" cols="12" class="pt-6 offset-md-4 d-flex justify-end">
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                class="text-capitalize"
                v-bind="attrs"
                v-on="on"
                bottom
                block
                dark
                rounded
              >
                <v-icon size="20" class="mr-1">mdi-plus</v-icon>Invitar Usuario
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Invitar usuario</v-card-title>
              <v-card-text>
                <v-form ref="inviteForm">
                  <v-select
                    v-model="inviteAccount"
                    :items="accounts"
                    :rules="required"
                  ></v-select>
                  <v-text-field
                    v-model="inviteEmail"
                    label="Email"
                    type="email"
                    placeholder="Email"
                    :rules="required"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" @click="dialog = false" text>
                  Cancelar
                </v-btn>
                <v-btn color="primary" @click="inviteUser" text>
                  Invitar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :search="search"
        :items="users"
        :server-items-length="totalUsers"
        :options.sync="options"
        :footer-props="{
          'items-per-page-options': [5, 10, 20],
        }"
        disable-sort
      >
        <template v-slot:item="{ item, index }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ getUserStatus(item) }}</td>
            <td class="d-none d-sm-table-cell">
              {{ item.modificationTime | moment("MMMM DD YYYY, HH:mm") }}
            </td>
            <td>
              <div class="d-flex align-center justify-space-around">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon>
                      <v-icon
                        @click="deleteUser(item, index)"
                        color="red lighten-2"
                        v-bind="attrs"
                        v-on="on"
                        small
                        >delete</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Borrar Usuario</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import _debounce from "lodash.debounce";

import { objectToQueryString } from "@/commons/util.js";

export default {
  data() {
    return {
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      dialog: false,
      headers: [
        {
          text: "Nombre",
          align: "start",
          width: "25%",
        },
        {
          text: "Email",
          align: "start",
          width: "25%",
        },
        {
          text: "Status",
          align: "start",
          width: "15%",
        },
        {
          text: "Última modificación",
          width: "25%",
        },
        {
          text: "Acciones",
          align: "center",
          width: "10%",
        },
      ],
      totalUsers: 0,
      users: [],
      inviteAccount: null,
      accounts: [{ value: 1, text: "Default" }],
      inviteEmail: "",
      required: [(v) => !!v || "Este campo es requirido"],
    };
  },
  mounted() {
    this.loadUsers();
    this.debouncedLoadUsers = _debounce(this.loadUsers, 500);
  },
  methods: {
    loadUsers() {
      let queryObject = {
        offset: this.offset,
        limit: this.options.itemsPerPage,
      };
      if (this.search) {
        queryObject.search = this.search;
      }
      const queryString = objectToQueryString(queryObject);
      this.$http.get(`/api/accounts/users?${queryString}`).then((response) => {
        console.log(response);
        this.totalUsers = response.data.total_users;
        this.users = response.data.users;
      });
    },
    editDashboard(item) {
      this.$router.push({
        name: "Dashboard",
        params: { dashboardId: item.id },
      });
    },
    async deleteUser(item, index) {
      const res = await this.$confirm(
        ` <h1 class="subtitle-1">Estas seguro que quieres eliminar el usuario <span class="font-weight-bold">${item.name}</span>?</h1>`,
        {
          buttonTrueText: "Eliminar",
          buttonFalseText: "Cerrar",
          buttonTrueColor: "red lighten-2",
          color: "primary",
          icon: "delete",
          title: "Eliminar Usuario",
          width: 600,
        }
      );
      if (res) {
        this.$http.delete(`/api/dashboards/${item.id}`).then((response) => {
          console.log(response);
          this.dashboards.splice(index, 1);
          this.$eventBus.$emit(
            "showNotification",
            `Usuario ${item.name} eliminado satisfactoriamente`,
            "success"
          );
        });
      }
    },
    getUserStatus(item) {
      switch (item.status) {
        case 0:
          return "Activo";
        case 1:
          return "Desactivado";
        case 2:
          return "Bloquead@";
        case 3:
          return "Clave Expirada";
        default:
          return "--";
      }
    },
    inviteUser() {
      if (this.$refs.inviteForm.validate()) {
        console.log("inviteUser");
        this.$http
          .post("/accounts/invite", {
            accountId: this.inviteAccount,
            email: this.inviteEmail,
          })
          .then((response) => {
            console.log(response.data);
          });
      }
    },
  },
  computed: {
    offset() {
      return (
        this.options.itemsPerPage * this.options.page -
        this.options.itemsPerPage
      );
    },
  },
  watch: {
    options: function () {
      this.loadUsers();
    },
    search: function () {
      this.debouncedLoadUsers();
    },
  },
};
</script>

<style>
</style>